import { useAuthStatus } from 'src/provider/auth';
import { useOptionDialog } from 'src/provider/optionDialog';

import DeleteButton from '../DeleteButton/DeleteButton';
import ReportButton from '../ReportButton/ReportButton';

export default () => {
  const { authStatus } = useAuthStatus();
  const {
    optionDialogState: { isAuthor },
  } = useOptionDialog();
  if (authStatus === 'authenticated' && isAuthor) {
    return <DeleteButton />;
  }
  return <ReportButton />;
};
